import { PortfolioSymbolQuantity } from 'portfolio/PortfolioSelection';
import { IntraDayProfileStreamRequest } from 'communication/types/intraDayProfile/IntraDayProfileStreamRequest';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { buildIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';

const {
    selectors: { selectConfigState },
} = buildIntraDayProfileConfigSlice();

export const mapSelectionToSymbolString: (
    selectedSymbolQuantities: PortfolioSymbolQuantity[]
) => string = (selectedSymbolQuantities) =>
    selectedSymbolQuantities.reduce(
        (res, item, index) =>
            index === 0
                ? `${item.symbol ?? ''},${item.qty}`
                : `${res}|${item.symbol ?? ''},${item.qty}`,
        ''
    );

export function createIntraDayProfileStreamRequest(
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    _appSettings: AppSettingsState,
    state: State
): IntraDayProfileStreamRequest | undefined {
    let selectionToUse = portfolioSelection;
    if (
        selectionToUse.selectedSymbolQuantities.length === 1 &&
        !selectionToUse.selectedSymbol
    ) {
        // No symbols so try the Instinet symbology...
        selectionToUse =
            PortfolioSelectionWrapper.buildWithInstinetSymbology(
                portfolioSelection
            );
    }

    const { selectedSymbolQuantities, symbology } = selectionToUse;
    const { bucketSize } = selectConfigState(state, widgetKey);

    return selectedSymbolQuantities.length > 0
        ? {
              symQty: mapSelectionToSymbolString(selectedSymbolQuantities),
              symbology,
              bucketSize: bucketSize!,
          }
        : undefined;
}
